import { Person } from './person.model';
import { CostStatuses } from './cost.model';

export class Note {
    constructor(
        public createdAt: string,
        public createdBy: Person | number,
        public costStatus: CostStatuses | string,
        public text: string,
    ) { }

    static adapt(item: any): Note {
        return new Note(
            item.createdAt,
            item.createdBy,
            item.costStatus,
            item.text,
        );
    }
}